import { atom } from 'jotai'

import { AwardsFile } from 'types/AwardsFile'

export const awardsFilesAtom = atom<AwardsFile[]>([])
